let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aaDxK")).then(() => parcelRequire('e6Gy7'));